import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/alerts/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Alerts'),
});
